var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSipid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00004 14.5C8.77837 14.5 8.56671 14.4125 8.41004 14.255L1.93754 7.77167C0.240872 6.07167 0.240872 3.30584 1.93754 1.60584C2.75671 0.785836 3.85087 0.333336 5.01671 0.333336C6.18254 0.333336 7.27671 0.785836 8.09587 1.60584L9.00004 2.51167L9.90337 1.60667C10.7234 0.785836 11.8175 0.333336 12.9834 0.333336C14.1492 0.333336 15.2434 0.785836 16.0625 1.60584C17.7592 3.30584 17.7592 6.07167 16.0634 7.77167L9.59004 14.2558C9.43337 14.4125 9.22171 14.5 9.00004 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSipid);
export default __webpack_public_path__ + "static/media/sipid.39b472e6adc4e66fb3dd72e9a703ed83.svg";
export { ForwardRef as ReactComponent };